import { memo } from 'react';
import { BellRing, Bookmark, Pin } from 'lucide-react';
import { Tooltip } from '@cyphex/ui';
import type { Message } from '@cyphex/types';
import { formatListStamp } from '../../lib/time';

interface MessageFlagsProps {
  message: Message;
}

/**
 * The small state icons on the author line: pinned for everyone, saved and
 * reminder for the caller alone. Kept together so the header row stays one
 * element rather than three conditionals inlined in the bubble.
 */
export const MessageFlags = memo(function MessageFlags({ message }: MessageFlagsProps) {
  return (
    <>
      {message.isPinned ? <Pin size={14} className="text-primary" aria-label="Pinned" /> : null}
      {message.isSaved ? <Bookmark size={14} className="text-primary" aria-label="Saved" /> : null}
      {message.reminderAt ? (
        <Tooltip content={`Reminder ${formatListStamp(message.reminderAt)}`}>
          <BellRing size={14} className="text-primary" aria-label="Reminder set" />
        </Tooltip>
      ) : null}
    </>
  );
});
